import React from "react"
import { getStatusStyle, getStatusBadgeStyle, getStatusTextStyle, snakeToTitleCase } from "../utils/helpers"
import { TYPOGRAPHY } from "../constants/theme"

const StatusBadge = ({
	status,
	variant = "default", // 'default', 'badge', 'dot', 'text', 'simple'
	showIcon = false,
	customText = null,
}) => {
	if (!status) return null

	const displayText = customText || snakeToTitleCase(status)

	if (variant === "badge") {
		return (
			<span style={getStatusBadgeStyle(status)}>
				{showIcon && (
					<span
						style={{
							display: "inline-block",
							width: 8,
							height: 8,
							borderRadius: "50%",
							backgroundColor: "currentColor",
							marginRight: 6,
						}}
					/>
				)}
				{displayText}
			</span>
		)
	}

	if (variant === "dot") {
		return (
			<span
				style={{
					display: "inline-flex",
					alignItems: "center",
					gap: 6,
					...getStatusStyle(status),
				}}
			>
				<span
					style={{
						display: "inline-block",
						width: 8,
						height: 8,
						borderRadius: "50%",
						backgroundColor: "currentColor",
					}}
				/>
				{displayText}
			</span>
		)
	}

	if (variant === "text") {
		return <span style={getStatusTextStyle(status)}>{displayText}</span>
	}

	if (variant === "simple") {
		return <span style={getStatusStyle(status)}>{displayText}</span>
	}

	// Default variant
	return <span style={getStatusTextStyle(status)}>{displayText}</span>
}

export default StatusBadge
